import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-router-dom";
import logo from "../Images/logo.png";

const Navigation = () => {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  return (
    <div className="sticky top-0 z-50 w-full bg-[#FAF6F1] before:content-[''] before:absolute before:bottom-0 before:left-0 before:w-full before:h-[5px] before:bg-[length:400%_400%] before:bg-gradient-to-r before:from-[#9D2026] before:via-[#23ABC2] before:to-[#F68F27] before:animate-gradientBorder">
      <div className="max-w-[1500px] mx-auto px-6 md:px-24 h-20 flex items-center justify-between text-[#008080] relative">
        {/* Left: Logo and Brand Name */}
        <div className="flex items-center gap-4">
          <img
            src={logo}
            alt="Logo"
            className="w-[60px] h-[60px] object-contain"
          />
          <h1 className="text-2xl text-[#DB7208] font-bold whitespace-nowrap">AURAH LEISURE</h1>
        </div>

        {/* Right: Desktop Navigation Links */}
        <ul className="hidden md:flex gap-6 text-m font-poppins">
          <li>
            <Link to="/" 
            className="relative after:content-[''] after:absolute after:w-0 after:h-[2px] after:left-0 after:bottom-[-4px] after:bg-gradient-to-r after:from-[#E3B778] after:to-[#E3D6A0] after:transition-all after:duration-500 hover:after:w-full"
            >HOME</Link>
          </li>
          <li>
            <Link to="/about-us"
            className="relative after:content-[''] after:absolute after:w-0 after:h-[2px] after:left-0 after:bottom-[-4px] after:bg-gradient-to-r after:from-[#E3B778] after:to-[#E3D6A0] after:transition-all after:duration-500 hover:after:w-full"
            >ABOUT US</Link>
          </li>
          <li>
            <Link to="/services"
            className="relative after:content-[''] after:absolute after:w-0 after:h-[2px] after:left-0 after:bottom-[-4px] after:bg-gradient-to-r after:from-[#E3B778] after:to-[#E3D6A0] after:transition-all after:duration-500 hover:after:w-full"
            >SERVICES</Link>
          </li>
          <li>
            <Link to="/test"
            className="relative after:content-[''] after:absolute after:w-0 after:h-[2px] after:left-0 after:bottom-[-4px] after:bg-gradient-to-r after:from-[#E3B778] after:to-[#E3D6A0] after:transition-all after:duration-500 hover:after:w-full"
            >TESTIMONIALS</Link>
          </li>
          <li>
            <Link to="/contact"
            className="relative after:content-[''] after:absolute after:w-0 after:h-[2px] after:left-0 after:bottom-[-4px] after:bg-gradient-to-r after:from-[#E3B778] after:to-[#E3D6A0] after:transition-all after:duration-500 hover:after:w-full"
            >CONTACT</Link>
          </li>
        </ul>

        {/* Mobile Toggle Icon */}
        <div
          onClick={handleNav}
          className="block md:hidden z-50 cursor-pointer"
        >
          {!nav ? <AiOutlineMenu size={24} /> : <AiOutlineClose size={24} />}
        </div>

        {/* Mobile Nav Drawer */}
        <div
          className={`md:hidden fixed top-0 left-0 w-[65%] h-full bg-[#E3EEF8] border-r border-[#014D66] z-40 ease-in-out duration-300 ${
            nav ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="px-6 py-4">
            <h1 className="text-2xl font-bold text-[#014D66] mb-6">
              AURAH LEISURE
            </h1>
            <ul className="space-y-4 text-[#014D66] font-poppins">
              <li>
                <Link to="/" onClick={handleNav}>HOME</Link>
              </li>
              <li>
                <Link to="/about-us" onClick={handleNav}>ABOUT US</Link>
              </li>
              <li>
                <Link to="/services" onClick={handleNav}>SERVICES</Link>
              </li>
              <li>
                <Link to="/test" onClick={handleNav}>TESTIMONIALS</Link>
              </li>
              <li>
                <Link to="/contact" onClick={handleNav}>CONTACT</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
